import React, { forwardRef } from "react";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// Components
import Text, { types } from "../../components/Text/Text";
import { ButtonBase } from "../../../node_modules/@material-ui/core/index";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    marginTop: theme.spacing(10),
    width: 812,
    maxWidth: "35%",
    flex: "1 1",
    backgroundColor: "#fff",
    borderRadius: "40px",
    boxShadow: "0px 1px 30px #0000000D",
    padding: "80px",
    [theme.breakpoints.down("md")]: {
      width: 600,
      flex: "initial",
      maxWidth: "initial",
      margin: theme.spacing(5, 0),
      padding: "60px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 12px",
      width: "100%",
      backgroundColor: "transparent",
      boxShadow: "none",
      margin: theme.spacing(4, 0, 2)
    }
  },
  imageWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2)
    }
  },
  icon: {
    height: 90,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  badgeIcon: {
    height: 105,
    [theme.breakpoints.down("md")]: {
      height: 80
    },
    [theme.breakpoints.down("sm")]: {
      height: 70
    }
  },
  badgeButton: {
    padding: theme.spacing(4, 2),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2)
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(4, 2),
      margin: 0
    }
  }
}));

const AccreditationSectionInfo = forwardRef(
  (
    {
      className,
      icon,
      title,
      certificate,
      description,
      badgeIcon,
      badgeLink,
      file,
      isMobile,
      ...rest
    },
    ref
  ) => {
    const classes = useStyles({ icon, badgeIcon });

    return (
      <Paper className={`${classes.root} ${className}`} {...rest} ref={ref}>
        <div className={classes.imageWrapper}>
          <img className={classes.icon} src={icon} alt="icon" />
          {isMobile && (
            <ButtonBase
              className={classes.badgeButton}
              component="a"
              href={file}
              target="_blank"
            >
              <img
                className={classes.badgeIcon}
                src={badgeIcon}
                alt="badgeIcon"
              />
            </ButtonBase>
          )}
        </div>
        <Text type={types.accreditationInfoTitle}>{title}</Text>
        <Text type={types.accreditationInfoCertificate}>{certificate}</Text>
        <Text type={types.accreditationInfoDescription}>{description}</Text>
        {!isMobile && (
          <ButtonBase
            className={classes.badgeButton}
            component="a"
            href={file}
            target="_blank"
          >
            <img
              className={classes.badgeIcon}
              src={badgeIcon}
              alt="badgeIcon"
            />
          </ButtonBase>
        )}
      </Paper>
    );
  }
);

export default AccreditationSectionInfo;
